
export const once = (e) => {

		var circle = document.getElementById('onload-overlay');
		var diameter = 2 * Math.sqrt(Math.pow(window.innerWidth, 2) + Math.pow(window.innerHeight, 2));
		var color = "green";

		function sizingCircle(){
			circle.style.width = diameter + 'px';
			circle.style.height = diameter + 'px';
			circle.classList.add('loading');
		}
		sizingCircle();

		const onMouseMove = (e) =>{
		  circle.style.left = (e.pageX - diameter/2) + 'px';
		  circle.style.top = (e.pageY - diameter/2) + 'px';
		}
		document.addEventListener('mousemove', onMouseMove);

}